<script lang="ts">
	import { slide } from 'svelte/transition';
	import IconExpandMore from 'virtual:icons/material-symbols/expand-more-rounded';
	import { t } from './i18n/tranlsator.svelte';

	interface Props {
		reasoningContent: string;
		hasContent: boolean;
	}

	let { reasoningContent, hasContent }: Props = $props();

	let expanded: boolean | null = $state(false);

	$effect(() => {
		if (hasContent) {
			expanded = false;
		}
	});

	function toggle() {
		expanded = !expanded;
	}
</script>

<div class="reasoning-block">
	<button class="reasoning-toggle" onclick={toggle} aria-expanded={expanded}>
		<div class="icon" class:rotated={expanded}>
			<IconExpandMore />
		</div>
		<span>{t('chat.reasoning')}</span>
	</button>
	{#if expanded}
		<div class="reasoning-content" transition:slide={{ duration: 200 }}>
			<p>{reasoningContent}</p>
		</div>
	{/if}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.reasoning-block {
		.reasoning-toggle {
			@include lib.flex-row();
			@include lib.flex-align(flex-start, center);
			gap: 0.25rem;
			padding: 0.25rem 0.5rem 0.25rem 0;
			background: transparent;
			border: none;
			color: var(--text-tertiary);
			font-size: 0.75rem;
			cursor: pointer;

			&:hover {
				color: var(--text-secondary);
			}

			.icon {
				flex-shrink: 0;
				transition: transform 200ms ease;
				@include lib.flex-row();
				@include lib.flex-align();

				&.rotated {
					transform: rotate(180deg);
				}
			}
		}

		.reasoning-content {
			padding: 0.25rem 0.5rem;
			border-left: 2px solid var(--border-subtle);
			margin-left: 0.25rem;

			p {
				color: var(--text-tertiary);
				font-size: 0.75rem;
				line-height: 1.5;
				margin: 0;
				white-space: pre-wrap;
			}
		}
	}
</style>
